import {
  IconAlertOctagon,
  IconAlertTriangle,
  IconInfoCircle,
} from '@tabler/icons-react';

export const NOTICE_TYPE_CONFIG = {
  STOERUNG: { color: 'red',    labelDE: 'Störung', Icon: IconAlertOctagon  },
  WARTUNG:  { color: 'orange', labelDE: 'Wartung', Icon: IconAlertTriangle },
  INFO:     { color: 'blue',   labelDE: 'Info',    Icon: IconInfoCircle    },
} as const;

export type NoticeType = keyof typeof NOTICE_TYPE_CONFIG;
